import { render, staticRenderFns } from "./Account.vue?vue&type=template&id=848c8d7a&scoped=true"
import script from "./Account.vue?vue&type=script&lang=ts"
export * from "./Account.vue?vue&type=script&lang=ts"
import style0 from "./Account.vue?vue&type=style&index=0&id=848c8d7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848c8d7a",
  null
  
)

export default component.exports